import { useQuery } from '@apollo/client'
import { useActiveChannelInstance } from '@chain-zen/chat'
import React from 'react'

import { POST_WITH_RATES } from '../../../data/queries/offer'
import type { IPostOfferReturnType } from '../../../types/post'
import { CarrierDetails } from './carrier-details'
import { PostInfo } from './post-info'
import { PostRates } from './post-rates'
import { getChatPostMetadata, syncPostDataInPostOfferChatMetadata } from './utils'

interface OriginalPosterViewProps {
  offer: IPostOfferReturnType | null
  postID: string
}

/**
 * OriginalPosterView component displays the post details to owner of the post on inbox page in right section.
 */
export const OriginalPosterView = ({ offer, postID }: OriginalPosterViewProps) => {
  const channel = useActiveChannelInstance()

  const { data } = useQuery(POST_WITH_RATES, {
    fetchPolicy: 'network-only',
    onCompleted: async ({ getPostByID: post }) => {
      if (post && channel) {
        const chatPostMetadata = getChatPostMetadata(post)
        await syncPostDataInPostOfferChatMetadata({
          chatPostMetadata,
          postChannel: channel
        })
      }
    },
    skip: !postID,
    variables: { id: postID }
  })

  const post = data?.getPostByID

  if (!offer || !post) return null

  return (
    <div className="flex flex-col gap-4">
      {!!post && <PostInfo post={post} tmsURL={post.tmsURL} />}
      {!!post && <PostRates post={post} />}
      {!!offer?.user && !!offer.workspace?.company && (
        <CarrierDetails
          user={offer.user}
          workspace={{
            company: offer.workspace.company,
            id: offer.workspace.id
          }}
        />
      )}
    </div>
  )
}
